import { redirect, RouteObject } from 'react-router-dom'
import axios from 'axios'
import { base_url } from 'env'

// Importer les pages
import ResourcesPage from 'pages/Resources/Resources'
import ResourceCreatePage from 'pages/Resources/ResourceCreate'
import ResourcePreviewPage from 'pages/Resources/ResourcePreview'
import ResourceEditPage from 'pages/Resources/ResourceEdit' // Nouvelle page
import ResourceUploadPage from 'pages/Resources/ResourceUpload' // Nouvelle page

// Un loader commun pour récupérer les données d'une ressource
const resourceLoader = async ({ params }: { params: { id?: string } }) => {
  try {
    const response = await axios.get(`${base_url}/resource/${params.id}`)
    return response.data
  } catch (error) {
    console.error(error)
    return redirect('/resources')
  }
}

export const ResourceRoutes: RouteObject[] = [
  {
    path: '/resources',
    loader: async () => {
      try {
        const response = await axios.get(base_url + '/resource/')
        return response.data
      } catch (error) {
        console.error(error)
        return []
      }
    },
    element: <ResourcesPage />,
  },
  {
    path: '/resource',
    element: <ResourceCreatePage />,
  },
  {
    path: '/resource/:id',
    loader: resourceLoader, // Utilisation du loader commun
    element: <ResourcePreviewPage />,
  },
  {
    path: '/resource/:id/edit',
    loader: resourceLoader, // Utilisation du loader commun
    element: <ResourceEditPage />,
  },
  {
    path: '/resource/:id/upload',
    loader: resourceLoader, // Utilisation du loader commun
    element: <ResourceUploadPage />,
  },
]
